import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=605f0690&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=605f0690&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f0690",
  null
  
)

export default component.exports